import * as workers from '../workers';

export const SET_BULK_PLANT_SHIFT_MODAL_PARAM = '@shifts/SET_BULK_PLANT_SHIFT_MODAL_PARAM';

// SET_BULK_PLANT_SHIFT_MODAL_PARAM;
export const setBulkPlantShiftModalParam = (param) => workers.setBulkPlantShiftModalParam(param);
